import { techIconMap } from '../../../../assets/techIcons';

export const techIcons = [
  [
    { text: 'Kotlin', icon: techIconMap.Kotlin },
    { text: 'Java', icon: techIconMap.Java },
    { text: 'Swift', icon: techIconMap.Swift },
    { text: 'Objective-C', icon: techIconMap.ObjectiveC },
    { text: 'C#', icon: techIconMap['C#'] },
    { text: 'JavaScript', icon: techIconMap.JavaScript },
    { text: 'Dart', icon: techIconMap.Dart },
    { text: 'Python', icon: techIconMap.Python },
  ],
  [
    { text: 'Android SDK', icon: techIconMap['Android SDK'] },
    { text: 'iOS SDK', icon: techIconMap['iOS SDK'] },
    { text: 'Flutter', icon: techIconMap.Flutter },
    { text: 'React Native', icon: techIconMap.ReactNative },
    { text: 'React', icon: techIconMap.React },
    { text: 'Ionic', icon: techIconMap.Ionic },
    { text: 'Cordova', icon: techIconMap.Cordova },
    { text: 'Mendix', icon: techIconMap.Mendix },
  ],
  [
    { text: 'Xamarin', icon: techIconMap.Xamarin },
    { text: 'FlutterFlow', icon: techIconMap.FlutterFlow },
    { text: 'Node.JS', icon: techIconMap.NodejsPlatform },
    { text: 'Firebase', icon: techIconMap.Firebase },
    { text: 'Supabase', icon: techIconMap.SupabaseLogo },
    { text: 'Tizen SDK', icon: techIconMap.Tizen },
    { text: 'Unity', icon: techIconMap.Unity },
  ],
  [
    { text: 'ARKit', icon: techIconMap.ARKit },
    { text: 'Vision OS', icon: techIconMap.VisionOS },
    { text: 'Car Play', icon: techIconMap.CarPlay },
    { text: 'Android Auto', icon: techIconMap.AndroidAuto },
    { text: 'Watch OS', icon: techIconMap.WatchOS },
    { text: 'Wear OS', icon: techIconMap.WearOS },
    { text: 'Android TV', icon: techIconMap.AndroidTV },
  ],
  [
    { text: 'HealthConnect', icon: techIconMap.HealthConnect },
    { text: 'NFC', icon: techIconMap.NFC },
    { text: 'BLE', icon: techIconMap.Bluetooth },
    { text: 'GPS', icon: techIconMap.GPS },
    { text: 'ApplePay', icon: techIconMap.ApplePay },
    { text: 'GooglePay', icon: techIconMap.GooglePay },
    { text: 'In-App-Purchases', icon: techIconMap.InAppPurchases },
  ],
];
